"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CertificateProductSlug;
(function (CertificateProductSlug) {
    CertificateProductSlug["CIMA_REPLACEMENT_CERTIFICATE"] = "cima-certificate";
})(CertificateProductSlug = exports.CertificateProductSlug || (exports.CertificateProductSlug = {}));
//# sourceMappingURL=product-certificate.js.map